import BooleanSetting from "./BooleanSetting";
import ColorSetting from "./ColorSetting";
import FileSetting from "./FileSetting";
import NumberSetting from "./NumberSetting";
import SelectorSetting from "./SelectorSetting";
import TextSetting from "./TextSetting";
import ElementSetting from "./ElementSetting";

export default {
  BooleanSetting,
  ColorSetting,
  ElementSetting,
  FileSetting,
  NumberSetting,
  SelectorSetting,
  TextSetting
};
